import type { FaireProductEntity } from "../../entity_types/product";

export const beverage_2: FaireProductEntity = {
  token: "beverage-2",
  type: "product",
  name: "Organic Tea Collection",
  brandName: "Tea Leaf Co.",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/d43ebe23f538540457ff3dc6186e0b09d80aa125e15539792ab6fdb3bfccaeb6.webp",
  priceDollars: 16,
  msrpDollars: 24,
  freeShipping: false,
  isBestseller: false,
  description: "",
  tags: [],
  inStock: true,
  categoryTokens: ["cat_food-drink"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-products-migration",
  },
};
